export const OIDC_LOGINHINT_JWT_PROPERTY_TYPE_ID = '143';
export const OIDC_ID_TOKEN_USER_ATTRIBUTES_PROPERTY_TYPE_ID = '151';


export const OIDC_LOGIN_HINT_WTRSA_PRIVATE_KEY_PROPERTY_TYPE_ID = '144';
export const OIDC_LOGIN_HINT_WTRSA_PUBLIC_KEY_PROPERTY_TYPE_ID = '145';

export const REQUIRED_FOR_SELF_SERVICE_CONFIG_PROPERTY_NAME = 'requiredForSelfServiceVerification';
export const DO_NOT_SAVE_TO_PDS_PROPERTY_NAME = 'doNotSaveToPDS';

export const LOGIN_HINT_PROPERTY_TYPE_IDS = [
    OIDC_ID_TOKEN_USER_ATTRIBUTES_PROPERTY_TYPE_ID,
    OIDC_LOGIN_HINT_WTRSA_PRIVATE_KEY_PROPERTY_TYPE_ID,
    OIDC_LOGIN_HINT_WTRSA_PUBLIC_KEY_PROPERTY_TYPE_ID,
    OIDC_LOGINHINT_JWT_PROPERTY_TYPE_ID
];

export const LOGIN_HINT_DOCUMENTATION_SHORTNAME  = 'login-hint-widget';

export const OIDC_LOGINHINT_EXPIRATION_PROPERTY_TYPE_ID = '405';
